/* Copyright (c) 2022-2025, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { DatePipe } from '@angular/common';
import { formatLogString } from '../common/common-utils';
import { LogTracerActions } from '../constants/logtracer_constants';

const logTracerStack = [];

function autoClosingOfLogs(level: string, datePipe: DatePipe, logArgs?: any[]) {
    while (logTracerStack.length !== 0) {
        const newLog = `${datePipe.transform(new Date(), 'yyyy-MM-dd HH:mm:ss.SSS')} ${[level]} ${logArgs[0]} ${
            logTracerStack[logTracerStack.length - 1]
        } ${LogTracerActions.close}`;
        console.log(newLog);
        logTracerStack.pop();
    }
}

function formatLogTracer(serviceName: string, level: string, datePipe: DatePipe, logArgs?: any[]): string {
    /* Checking only main tasks with Tracer enum to provide correct levelling of logs
     */
    if (logArgs.length >= 3 && logArgs[1].toString().includes('Tracer')) {
        /* If 2 main tasks are started but without closing second task if first task is directly closed,
        this does auto-closing of that missed task. Eg: Search followed by evidence panel and closing search directly.
        */
        if (logTracerStack[logTracerStack.length - 1] !== logArgs[1]) {
            if (logArgs[2] === LogTracerActions.close) {
                const newLog = `${datePipe.transform(new Date(), 'yyyy-MM-dd HH:mm:ss.SSS')} ${[level]} ${logArgs[0]} ${
                    logTracerStack[logTracerStack.length - 1]
                } ${logArgs[2]}`;
                logTracerStack.pop();
                console.log(newLog);
                if (logTracerStack.length) {
                    logTracerStack.pop();
                }
            } else if (logArgs[2] === LogTracerActions.open && logTracerStack.includes(logArgs[1])) {
                /* If two main tasks are started and without closing either of them a new task gets opened this handles auto closing in
            such case. Eg: Search followed by opening evidence panel and starting search again without closing earlier ones
            */
                autoClosingOfLogs(level, datePipe, logArgs);
            }
            /* Pushing into stack to keep track of opened main tasks and maintain levelling
             */
            logTracerStack.push(logArgs[1]);
        } else if (logTracerStack[logTracerStack.length - 1] === logArgs[1]) {
            /* Checking only sub tasks like Endpoint requests etc i.e, without enums
            If the opened task is closed it is removed from stack
             */
            logTracerStack.pop();
        }
    } else if (logArgs[1] === 'Clicked on Back button') {
        /* Handling different screens to keep track of currently opened screen
     i.e, opening seemore screen, search screen and clicking on back button
    */
        autoClosingOfLogs(level, datePipe, logArgs);
        return undefined;
    }

    const requiredString = formatLogString(serviceName, level, datePipe, logArgs);
    return requiredString;
}

export { formatLogTracer };
